import {ofType} from 'redux-observable';
import {of, zip} from 'rxjs';
import {mergeMap, catchError, flatMap} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import * as ChildObservables from 'web-app/react/entities/children/epics';
import * as ContactObservables from 'web-app/react/entities/contacts/epics';

import * as Actions from './actions';

const fetchChildProfile = action$ =>
    action$.pipe(
        ofType(Actions.fetchChildProfile.type),
        mergeMap(({payload}) => {
            const {childId} = payload;

            return zip(
                ChildObservables.fetchChildObservable(childId),
                ContactObservables.fetchChildContactsObservable(childId),
            ).pipe(
                flatMap((actions: any[]) => {
                    return [...actions, Actions.fetchChildProfileSuccess.action()];
                }),
                catchError(e => of(Actions.fetchChildProfileFailed.action(e))),
            );
        }),
    );

export default combineEpics(fetchChildProfile);
